<template>
	<div class="add-btn" @click="addbtnClick">+{{ value }}</div>
</template>
<script>
export default {
	props: {
		value: {
			type: String,
			default: () => {
				return "新增";
			},
		},
	},
	data() {
		return {};
	},
	methods: {
		addbtnClick() {
			this.$emit("addbtnClick");
		},
	},
};
</script>
<style lang="less" scoped>
.add-btn {
	width: 75px;
	height: 30px;
	line-height: 14px;
	text-align: center;
	font-size: 14px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: white;
	background: rgba(54, 179, 116, 1);
	border-radius: 1px;
	padding: 8px 16px;
}
</style>
